import type { ComputedRef, InjectionKey } from "vue";
import { computed, hasInjectionContext, inject } from "vue";
import { useAuthStore } from "../AuthStore/useAuthStore";

export const VIEW_MANAGEMENT_MODULE_KEY: InjectionKey<ComputedRef<boolean>> = Symbol("viewManagementModule");

/**
 * Web gates editing, adding, reordering and the view defaults behind the staff-only
 * `enableViewManagementModule` preference by providing `useViewManagementModulePreference()` under
 * `VIEW_MANAGEMENT_MODULE_KEY`. Apps that do not provide it (CMS) always allow view management.
 */
export function useViewManagementModuleEnabled(): ComputedRef<boolean> {
  if (!hasInjectionContext()) {
    return computed(() => true);
  }
  return inject(VIEW_MANAGEMENT_MODULE_KEY, () => computed(() => true), true);
}

export function useViewManagementModulePreference(): ComputedRef<boolean> {
  const { userPreferences } = useAuthStore();
  return computed(() => userPreferences.value?.enableViewManagementModule === true);
}
